module.exports = __webpack_public_path__ + "static/media/buttonsounds03.da3a25d4.wav";